import { useLayoutEffect } from "react";
import { useLocation } from "react-router";
const scrollPositions = new Map();
const useScrollRestoration = (getElement) => {
    const { pathname } = useLocation();
    useLayoutEffect(() => {
        var _a;
        const element = getElement();
        if (!element)
            return;
        element.scrollTop = (_a = scrollPositions.get(pathname)) !== null && _a !== void 0 ? _a : 0;
        return () => {
            scrollPositions.set(pathname, element.scrollTop);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);
};
export default useScrollRestoration;
//# sourceMappingURL=useScrollRestoration.js.map